import { useMutation } from "@apollo/client"
import styled from "@emotion/styled"
import { Button, notify, Text, TextInputField, theme } from "@pallet-hq/hegel"
import { Formik } from "formik"
import { RESET_PASSWORD_MUTATION } from "page-components/forgot-password/mutations"
import * as Yup from "yup"

const ForgotPasswordPage = () => {
    const [resetPassword] = useMutation(RESET_PASSWORD_MUTATION)

    return (
        <FullPageDiv>
            <InfoDiv>
                <Text variant="headlineMedium" marginLeft="xxsmall">
                    Find your Pallet account
                </Text>
                <Divider />
                <Formik
                    initialValues={{ resetEmail: "" }}
                    onSubmit={(values, { setSubmitting }) =>
                        resetPassword({
                            variables: { email: values.resetEmail },
                        }).then(({ data }) => {
                            if (data?.resetPassword?.ok) {
                                setSubmitting(false)
                                notify.success(
                                    "An email to reset your password is on its way to your inbox."
                                )
                            } else {
                                notify.fail(
                                    "Something went wrong. Are you sure you entered the right email?"
                                )
                            }
                        })
                    }
                    validationSchema={Yup.object().shape({
                        resetEmail: Yup.string()
                            .required("Email required")
                            .email("Please enter a valid email"),
                    })}
                >
                    {({ handleSubmit, isSubmitting }) => (
                        <form onSubmit={handleSubmit}>
                            <TextInputField
                                type="email"
                                autoComplete="email"
                                placeholder="Enter your email address."
                                width="100%"
                                name="resetEmail"
                                label="Email Address"
                            />
                            <Button
                                type="submit"
                                loading={isSubmitting}
                                mt={3}
                                width="100%"
                            >
                                Reset password
                            </Button>
                        </form>
                    )}
                </Formik>
            </InfoDiv>
        </FullPageDiv>
    )
}

const FullPageDiv = styled.div`
    background-color: ${theme.colors.gray100};
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`

const InfoDiv = styled.div`
    max-width: 472px;
    width: 100%;
    background-color: ${theme.colors.white};
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    padding: 32px;
`

const Divider = styled.div`
    height: 1px;
    background: ${theme.colors.gray200};
    margin: ${theme.space.small} 0;
`

export default ForgotPasswordPage
